import React from 'react'
import buildInfo from '../../../build-info.json'

export const BuildInfoPage = () => (
  <pre>{JSON.stringify(buildInfo, null, 2)}</pre>
)
